import React, { memo, useCallback } from 'react'
import { map, switchMap } from 'rxjs/operators'
import { of } from 'rxjs'
import url from 'libraries/front-end-core/core/url'
import { deselectContent, observeSelected } from 'libraries/front-end-core/services/StateService'
import { shorten } from 'libraries/front-end-core/services/ShortenerService'
import { CURRENT_AWARENESS, CURRENT_AWARENESS_REVIEW } from 'constants/controllers'
import { URL_PDF_CA } from 'constants/urls'
import { ALL_AOLS, AOL_DISPLAY_NAMES } from 'constants/aol/aol'
import SelectedHeader from 'components/shared/SelectedHeader'
import AOLDropdown from 'components/shared/AOLDropdown'

const CaHeader = memo((props) => {
  const availableAol = ALL_AOLS.map(aol => ({
    label: AOL_DISPLAY_NAMES[aol],
    href: url(CURRENT_AWARENESS, { aol })
  }))
  const toUrl = (aol, selectedIds) => url(CURRENT_AWARENESS_REVIEW, { aol, selectedIds: selectedIds.map(v => v.replace('/', ':')) })
  const { aol } = props
  const getStateSource = useCallback(() => observeSelected('currentawareness').pipe(
    map(vs => Object.keys(vs).map(k => vs[k] > 0 ? k : null).filter(v => v !== null)),
    switchMap(
      selectedIds =>
        selectedIds.length
          ? shorten(toUrl(aol, selectedIds).replace(/#/, ''))
            .pipe(map(short => ({ selectedIds, short })))
          : of({ selectedIds: [], short: null })
    )), [aol])

  return (
    <div className='layout-width-constraint pt4 pb5 flex'>
      <AOLDropdown
        multi={false}
        label={AOL_DISPLAY_NAMES[aol]}
        options={availableAol}
        align='right'
      />
      <SelectedHeader
        {...{ ...props, stateSource: getStateSource() }}
        deselectAll={deselectContent.bind(null, 'currentawareness')}
        keyword={(l) => l === 1 ? 'article' : 'articles'}
        pdfUrl={URL_PDF_CA}
        dataHelpItem='catoolbar'
        displayWordDownload={false}
      />
    </div>
  )
})

export default CaHeader
